<div class="steps">
  <ng-container *ngIf="notLoading$()">
    <que-stepper *ngIf="stepsNames$()" [currentStep]="currentStep$()" [stepsNames]="stepsNames$()!"
      [isPreview]="isPreview" (ChangeStepEvent)="changePage($event)"></que-stepper>
  </ng-container>
</div>